import { useEffect, useState } from 'react';

let timer: NodeJS.Timeout = null;

export const useLoading = (loading: boolean, timeout?: number) => {
  const [loadingState, setLoadingState] = useState(true);

  useEffect(() => {
    setLoadingState(true);
    if (!loading) {
      timer = setTimeout(() => {
        setLoadingState(false);
      }, timeout ?? 200);
    }

    return () => {
      if (!timer) return;
      clearTimeout(timer);
    };
  }, [loading, timeout]);

  return [loadingState];
};
